import React from 'react';
import OptImage from '../utils/OptImage';

const Header = ({ onContactClick }) => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <OptImage src='logo-raw_kard7w'></OptImage>
          <div className="logo-section">
            <h1 className="main-title">Begin Your Personalized Aesthetic Journey</h1>
            <p className="tagline">Expert cosmetic and reconstructive surgery with Dr. Deepika Sinha in Bhopal</p>
          </div>
          <div className="header-actions">
            <button className="contact-btn" onClick={onContactClick}>
              <i className="fas fa-phone"></i>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;